import React, { useState } from "react";
import {
  Box,
  Grid,
  TextField,
  Typography,
  MenuItem,
  Button,
  Paper,
  Divider,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import httpCommon from "../../../http-common";
import { toast } from "sonner";

const AddPropertyData = () => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});

  const [form, setForm] = useState({
    property_name: "",
    zone: "",
    sub_location: "",
    availability: "",
    property_type: "",
    bed_rooms: "",
    built_up_area: "",
    plot_area: "",
    sale_price: "",
    final_price: "",
    rate_per_sqft: "",
    flat_on_floor: "",
    main_door_facing: "",
    bath_rooms: "",
    status: "",
    transaction_type: "",
    developer: "",
    total_floors: "",
    plot_facing: "",
    corner_property: "",
    plot_dimensions: "",
    approaching_road_width: "",
    gated_community: "",
    balconies: "",
    furnishing: "",
    year_built: "",
    total_project_extent: "",
    total_blocks: "",
    total_units: "",
    khata: "",
    other_advantages: "",
    approval_authority: "",
    towers: "",
    unit_numbers: "",
  });

  const numericFields = [
  "bed_rooms",
  "bath_rooms",
  "built_up_area",
  "plot_area",
  "sale_price",
  "final_price",
  "rate_per_sqft",
  "flat_on_floor",
  "total_floors",
  "approaching_road_width",
  "balconies",
  "year_built",
  "total_project_extent",
  "total_blocks",
  "total_units",
  "towers"
];

 const handleChange = (e) => {
  const { name, value } = e.target;

  // numeric fields → allow only numbers + decimal
  if (numericFields.includes(name)) {
    if (value === "" || /^\d*\.?\d*$/.test(value)) {
      setForm({ ...form, [name]: value });
    }
  } else {
    setForm({ ...form, [name]: value });
  }
};


const handleSubmit = async () => {
  const newErrors = {};

  numericFields.forEach((field) => {
    if (form[field] && isNaN(Number(form[field]))) {
      newErrors[field] = "Must be numeric";
    }
  });

  setErrors(newErrors);

  if (Object.keys(newErrors).length > 0) {
    toast.error("Please fix numeric fields");
    return;
  }

  try {
    await httpCommon.post("/property-data", form);
    toast.success("Property data added");
    navigate("/admin/property-data");
  } catch (err) {
    toast.error("Failed to save");
  }
};


  const selectYesNo = ["Yes", "No"];
const compactField = {
  "& .MuiInputBase-root": {
    height: 30,
    fontSize: 13
  },
  "& .MuiOutlinedInput-input": {
    padding: "8px 10px",
    fontSize: 13
  },

  // LABEL STYLE
  "& .MuiInputLabel-root": {
    fontSize: 13,
    background: "#fff",   // creates gap over border
    padding: "0 4px"      // horizontal space left+right
  },

  "& .MuiInputLabel-shrink": {
    fontSize: 14,
    top: 0
  }
};



  return (
    <Box p={2}>
      <Paper sx={{ p: 2, borderRadius: 3 }}>
        <Typography variant="h5" fontWeight={600} mb={1}>
          Add Asset Property Data
        </Typography>

        <Divider sx={{ mb: 3 }} />

        <Grid container spacing={2}>
          {/* BASIC */}
          <Grid item xs={12} md={6}>
            <TextField size="small" sx={compactField} fullWidth label="Property Name" name="property_name" value={form.property_name} onChange={handleChange} InputLabelProps={{ shrink: true }}/>
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField size="small" sx={compactField} fullWidth label="Zone" name="zone" value={form.zone} onChange={handleChange} InputLabelProps={{ shrink: true }}/>
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField size="small" sx={compactField} fullWidth label="Sub Location" name="sub_location" value={form.sub_location} onChange={handleChange} InputLabelProps={{ shrink: true }}/>
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField select size="small" sx={compactField} fullWidth label="Availability" name="availability" value={form.availability} onChange={handleChange} InputLabelProps={{ shrink: true }}>
              <MenuItem value="Ready">Ready</MenuItem>
              <MenuItem value="Under Construction">Under Construction</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField size="small" sx={compactField} fullWidth label="Property Type" name="property_type" value={form.property_type} onChange={handleChange} InputLabelProps={{ shrink: true }} />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField size="small" sx={compactField} fullWidth label="Bed Rooms" name="bed_rooms" value={form.bed_rooms} onChange={handleChange}   error={!!errors.bed_rooms} helperText={errors.bed_rooms} InputLabelProps={{ shrink: true }} />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField size="small" sx={compactField} fullWidth label="Bath Rooms" name="bath_rooms" value={form.bath_rooms} onChange={handleChange} error={!!errors.bath_rooms} helperText={errors.bath_rooms} InputLabelProps={{ shrink: true }} />
          </Grid>

          {/* AREA */}
          <Grid item xs={12} md={3}>
            <TextField size="small" sx={compactField} fullWidth label="Built Up Area" name="built_up_area" value={form.built_up_area} onChange={handleChange} error={!!errors.built_up_area} helperText={errors.built_up_area} InputLabelProps={{ shrink: true }} />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField size="small" sx={compactField} fullWidth label="Plot Area" name="plot_area" value={form.plot_area} onChange={handleChange} error={!!errors.plot_area} helperText={errors.plot_area} InputLabelProps={{ shrink: true }} />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField size="small" sx={compactField} fullWidth label="Rate Per Sqft" name="rate_per_sqft" value={form.rate_per_sqft} onChange={handleChange} error={!!errors.rate_per_sqft} helperText={errors.rate_per_sqft} InputLabelProps={{ shrink: true }} />
          </Grid>

          {/* PRICE */}
          <Grid item xs={12} md={3}>
            <TextField size="small" sx={compactField} fullWidth label="Sale Price" name="sale_price" value={form.sale_price} onChange={handleChange} error={!!errors.sale_price} helperText={errors.sale_price} InputLabelProps={{ shrink: true }} />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField size="small" sx={compactField} fullWidth label="Final Price" name="final_price" value={form.final_price} onChange={handleChange} error={!!errors.final_price} helperText={errors.final_price} InputLabelProps={{ shrink: true }} />
          </Grid>

          {/* DETAILS */}
          <Grid item xs={12} md={3}>
            <TextField size="small" sx={compactField} fullWidth label="Flat On Floor" name="flat_on_floor" value={form.flat_on_floor} onChange={handleChange} error={!!errors.flat_on_floor} helperText={errors.flat_on_floor} InputLabelProps={{ shrink: true }} />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField size="small" sx={compactField} fullWidth label="Main Door Facing" name="main_door_facing" value={form.main_door_facing} onChange={handleChange} InputLabelProps={{ shrink: true }} />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField size="small" sx={compactField} fullWidth label="Total Floors" name="total_floors" value={form.total_floors} onChange={handleChange} error={!!errors.total_floors} helperText={errors.total_floors} InputLabelProps={{ shrink: true }} />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField size="small" sx={compactField} fullWidth label="Plot Facing" name="plot_facing" value={form.plot_facing} onChange={handleChange} InputLabelProps={{ shrink: true }} />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField select size="small" sx={compactField} fullWidth label="Corner Property" name="corner_property" value={form.corner_property} onChange={handleChange} InputLabelProps={{ shrink: true }} >
              {selectYesNo.map((o) => <MenuItem key={o} value={o}>{o}</MenuItem>)}
            </TextField>
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField size="small" sx={compactField} fullWidth label="Plot Dimensions" name="plot_dimensions" value={form.plot_dimensions} onChange={handleChange} InputLabelProps={{ shrink: true }} />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField size="small" sx={compactField} fullWidth label="Road Width" name="approaching_road_width" value={form.approaching_road_width} error={!!errors.approaching_road_width} helperText={errors.approaching_road_width} onChange={handleChange} InputLabelProps={{ shrink: true }} />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField select size="small" sx={compactField} fullWidth label="Gated Community" name="gated_community" value={form.gated_community} onChange={handleChange} InputLabelProps={{ shrink: true }} >
              {selectYesNo.map((o) => <MenuItem key={o} value={o}>{o}</MenuItem>)}
            </TextField>
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField size="small" sx={compactField} fullWidth label="Balconies" name="balconies" value={form.balconies} onChange={handleChange} error={!!errors.Balconies} helperText={errors.Balconies} InputLabelProps={{ shrink: true }} />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField size="small" sx={compactField} fullWidth label="Furnishing" name="furnishing" value={form.furnishing} onChange={handleChange} InputLabelProps={{ shrink: true }} />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField size="small" sx={compactField} fullWidth label="Year Built" name="year_built" value={form.year_built} onChange={handleChange} error={!!errors.year_built} helperText={errors.year_built} InputLabelProps={{ shrink: true }} />
          </Grid>

          {/* PROJECT */}
          <Grid item xs={12} md={3}>
            <TextField size="small" sx={compactField} fullWidth label="Developer" name="developer" value={form.developer} onChange={handleChange} InputLabelProps={{ shrink: true }} />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField size="small" sx={compactField} fullWidth label="Total Project Extent" name="total_project_extent" value={form.total_project_extent} error={!!errors.total_project_extent} helperText={errors.total_project_extent} onChange={handleChange} InputLabelProps={{ shrink: true }} />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField size="small" sx={compactField} fullWidth label="Total Blocks" name="total_blocks" value={form.total_blocks} onChange={handleChange} error={!!errors.total_blocks} helperText={errors.total_blocks} InputLabelProps={{ shrink: true }} />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField size="small" sx={compactField} fullWidth label="Total Units" name="total_units" value={form.total_units} onChange={handleChange} error={!!errors.total_units} helperText={errors.total_units} InputLabelProps={{ shrink: true }} />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField size="small" sx={compactField} fullWidth label="Towers" name="towers" value={form.towers} onChange={handleChange} error={!!errors.towers} helperText={errors.towers} InputLabelProps={{ shrink: true }} />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField size="small" sx={compactField} fullWidth label="Unit Numbers" name="unit_numbers" value={form.unit_numbers} onChange={handleChange} InputLabelProps={{ shrink: true }} />
          </Grid>

          {/* LEGAL */}
          <Grid item xs={12} md={3}>
            <TextField size="small" sx={compactField} fullWidth label="KHATA" name="khata" value={form.khata} onChange={handleChange} InputLabelProps={{ shrink: true }} />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField size="small" sx={compactField} fullWidth label="Approval Authority" name="approval_authority" value={form.approval_authority} onChange={handleChange} InputLabelProps={{ shrink: true }} />
          </Grid>

          {/* STATUS */}
          <Grid item xs={12} md={3}>
            <TextField size="small" sx={compactField} fullWidth label="Status" name="status" value={form.status} onChange={handleChange} InputLabelProps={{ shrink: true }} />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField size="small" sx={compactField} fullWidth label="Transaction Type" name="transaction_type" value={form.transaction_type} onChange={handleChange} InputLabelProps={{ shrink: true }} />
          </Grid>

          {/* TEXTAREA */}
          <Grid item xs={12}>
            <TextField
              size="small" fullWidth
              multiline
              rows={3}
              label="Other Advantages"
              name="other_advantages"
              value={form.other_advantages}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }} 
            />
          </Grid>
        </Grid>

       <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
      <Button variant="outlined" onClick={() => navigate("/admin/property-data")}>
        Cancel
      </Button>

      <Button variant="contained" color="success" onClick={handleSubmit}>
        Save Property Data
      </Button>
    </Box>

      </Paper>
    </Box>
  );
};

export default AddPropertyData;
